import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { DashboardsDisplayGridRowDataFragmentGql } from './DashboardsDisplayGridRowFragmentGql';

export const VirtualConnectionTableDownstreamDashboardsFilteredByColumnQueryGql: DocumentNode = gql`
query VirtualConnectionTableDownstreamDashboardsFilteredByColumnQuery(
  $vizportalUrlId: String!,
  $selectedColumnId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: DashboardSortOrder!
) {
  virtualConnectionTables(filter: { vizportalUrlId: $vizportalUrlId }) {
    columnsConnection(filter: { id: $selectedColumnId }) {
      nodes {
        downstreamDashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${DashboardsDisplayGridRowDataFragmentGql}
`;
